export default __webpack_public_path__ + "static/media/ui-status-success.d66d6a74.svg";